<ng-content select="[wdxInfoCardLeading]"></ng-content>
<div class="info-card-body card-body" [ngClass]="bodyClasses">
    <ng-content select="[wdxInfoCardLabel]"></ng-content>
    <ng-content select="[wdxInfoCardSub]"></ng-content>
    <ng-content select="[wdxInfoCardAppendix]"></ng-content>
</div>
<ng-content select="[wdxInfoCardTrailing]"></ng-content>
